// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fake-owl.owl-carousel {\n    display: flex;\n}\n\n.fake-owl .owl-stage-outer {\n    width: 100%;\n}\n\n.fake-owl .owl-item {\n    flex-grow: 1;\n    flex-shrink: 0;\n}\n\n[data-zuu-goaway] {\n    display: inherit !important;\n}", ""]);
// Exports
module.exports = exports;
